export default __webpack_public_path__ + "17236cb84efa20b256b8be46b5387c8c.png";